<template>
    <v-dialog
            v-model="dialog"
            width="500"
    >
        <v-card>
            <v-card-title
                    class="headline primary lighten-1 white--text"
                    primary-title
            >
                Shapefile Hochladen und Anzeigen
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col>
                        Mithilfe eines hochgeladenen Shapefiles können sie die Layer direkt für ihre Felder betrachten.
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-file-input label="Shapefile *.zip" @change="uploadFile"
                                      accept="application/zip" type="file"/>
                    </v-col>
                </v-row>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-progress-circular v-if="loading"
                        indeterminate
                        color="accent"
                ></v-progress-circular>
                <v-btn
                        color="primary"
                        text
                        @click="addShapeToMap"
                        :disabled="file == null"
                >
                    Hochladen
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import LeafletServices from "@/services/leaflet.service";

    export default {
        name: "UploadForm",
        props: ['openDialog'],
        data() {
            return {
                loading: false,
                file: null
            }
        },
        methods: {
            closeDialog: function () {
                this.$emit("closeDialog")
            },
            uploadFile: function (file) {
                this.file = file
            },
            addShapeToMap: function () {
                let _this = this
                this.loading = true

                let reader = new FileReader();
                reader.onload = function () {
                    LeafletServices.addShapefile(reader.result)
                    _this.loading = false
                    _this.closeDialog()
                }

                reader.readAsArrayBuffer(this.file)
            }
        },
        computed: {
            dialog: {
                set: function () {
                    this.closeDialog()
                },
                get: function () {
                    return this.openDialog
                }
            }
        }
    }
</script>

<style scoped>

</style>